var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 137,
    viewBox: "0 0 160 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3257_4931)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.135 136.999C150.867 122.489 160 102.311 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 102.311 9.13348 122.489 23.8655 136.999H136.135Z",
    fill: "url(#paint0_linear_3257_4931)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8203 58.0486C40.9579 57.0601 41.8032 56.3242 42.8013 56.3242H93.9049C94.903 56.3242 95.7483 57.0601 95.8858 58.0486L105.139 124.556H31.5671L40.8203 58.0486Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.6339,
    y: 124.555,
    width: 85.4384,
    height: 11.8664,
    rx: 2,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.871 50.9883V122.606C134.871 130.239 130.001 136.427 123.993 136.427H96.3049",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.938,
    cy: 39.3199,
    r: 5.93322,
    fill: "#C7DAF1",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.262,
    cy: 48.1086,
    r: 5.93322,
    transform: "rotate(-72 125.262 48.1086)",
    fill: "#C7DAF1",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.478,
    cy: 61.6796,
    r: 5.93322,
    transform: "rotate(144 142.478 61.6796)",
    fill: "#C7DAF1",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.398,
    cy: 61.6812,
    r: 5.93322,
    transform: "rotate(-144 129.398 61.6812)",
    fill: "#C7DAF1",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.48,
    cy: 48.113,
    r: 5.93322,
    transform: "rotate(72 146.48 48.113)",
    fill: "#C7DAF1",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.942,
    cy: 51.7831,
    r: 8.30651,
    fill: "#F9C835",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2183 77.8237L39.636 116.96",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.732,
    cy: 86.2962,
    rx: 4.44992,
    ry: 10.3232,
    transform: "rotate(33 141.732 86.2962)",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.44992,
    cy: 10.3232,
    rx: 4.44992,
    ry: 10.3232,
    transform: "matrix(-0.838671 0.544639 0.544639 0.838671 125.401 91.6797)",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43407 136.39H140.514Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43407 136.39H140.514",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.036 136.39H148.783Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.036 136.39H148.783",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.392 130.492H105.139Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.392 130.492H105.139",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3257_4931",
    x1: 80,
    y1: -32.8247,
    x2: 80,
    y2: 173.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7DAF1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3257_4931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 137,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadConfig);
export default __webpack_public_path__ + "static/media/BadConfig.601a2552d397324faea65d656b140d27.svg";
export { ForwardRef as ReactComponent };